import { LAYOUTS } from './layouts';

export default function LayoutSelector({ onLayoutChange }) {
    return (
        <div className="brandy-layout-selector-wrapper">
            <p className="brandy-placeholder-instructions-txt">Select a container layout to start with.</p>
            <div className="brandy-layout-selector-item">
                {LAYOUTS.map((layout) => (
                    <div
                        key={layout.id}
                        className={`brandy-layout-option-item ${layout.rows > 1 ? 'brandy-multi-row' : ''}`}
                        onClick={() => onLayoutChange(layout)}
                    >
                        <div
                            className="brandy-layout-preview"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                gap: '5px',
                                width: '100%',
                                height: layout.rows > 1 ? '100px' : '50px', // Height is 50px for 1 row, 100px for multiple rows
                            }}
                        >
                            {Array.from({ length: layout.rows }).map((_, rowIndex) => {
                                // Calculate the start index of the current row in the template array
                                const start = rowIndex * layout.columns;
                                // Calculate the end index by adding the number of columns to the start
                                const end = start + layout.columns;
                                // Extract the column widths for this row from the template array
                                const rowTemplate = layout.template.slice(start, end);
                                return (
                                    <div
                                        key={rowIndex}
                                        style={{ display: 'flex', flex: 1, gap: '5px' }}
                                    >
                                        {rowTemplate.map((colWidth, colIndex) => (
                                            <div
                                                key={colIndex}
                                                className="brandy-layout-box"
                                                style={{
                                                    // Flex shorthand: grow factor is colWidth, shrink is 1, basis is 0
                                                    flex: `${colWidth} 1 0`,
                                                    boxSizing: 'border-box',
                                                }}
                                            />
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}